import React, { useRef, useEffect } from 'react';
import { InputWrapper, ZipCodeInputBox } from './ZipCodeInput.styles.js';

var ZipCodeInput = function ZipCodeInput(_a) {
  var setZipCode = _a.setZipCode,
      verified = _a.verified,
      setVerified = _a.setVerified,
      backgroundColor = _a.backgroundColor,
      verifiedBackground = _a.verifiedBackground,
      autoFocus = _a.autoFocus;
  var inputRefs = useRef([]);

  var createZipCode = function createZipCode() {
    var zipCode = 0;
    inputRefs.current.forEach(function (i) {
      if (zipCode === 0) {
        zipCode = i.value;
      } else {
        zipCode += i.value;
      }
    });
    return zipCode;
  };

  var clamp = function clamp(min, max, val) {
    return Math.max(min, Math.min(val, max));
  };

  var handleInput = function handleInput(index, e) {
    var nextIndex = clamp(0, 5 - 1, index + 1);
    var prevIndex = clamp(0, 5 - 1, index - 1);

    if (e.key === 'Backspace' || e.key === 'Delete') {
      inputRefs.current[index].value = null;
      setVerified(false);
      inputRefs.current[prevIndex].focus();
    } else if (e.key === 'ArrowLeft') {
      inputRefs.current[prevIndex].focus();
    } else if (e.key === 'ArrowRight') {
      inputRefs.current[nextIndex].focus();
    } else {
      if (inputRefs.current[index].value) {
        if (e.key >= '0' && e.key <= '9') {
          inputRefs.current[index].value = e.key;
          inputRefs.current[nextIndex].focus();
        }
      }
    }

    var counter = 0;
    inputRefs.current.forEach(function (ref) {
      if (ref.value) {
        counter++;
      }
    });
    setZipCode(createZipCode());

    if (counter === 5) {
      setVerified(true);
    }
  };

  useEffect(function () {
    var _a;

    if (inputRefs && inputRefs.current && inputRefs.current[0]) {
      (_a = inputRefs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, []);
  return React.createElement(InputWrapper, null, Array.from(Array(5).keys()).map(function (index) {
    return React.createElement("div", {
      key: index
    }, React.createElement(ZipCodeInputBox, {
      type: "number",
      onInput: function onInput(e) {
        return e.currentTarget.value = e.currentTarget.value.slice(0, 1);
      },
      onKeyUp: function onKeyUp(e) {
        return handleInput(index, e);
      },
      verified: verified,
      backgroundColor: backgroundColor,
      verifiedBackground: verifiedBackground,
      marginLeft: index === 3,
      ref: function ref(_ref) {
        return inputRefs.current[index] = _ref;
      },
      autoFocus: index === 0 && autoFocus
    }));
  }));
};

export { ZipCodeInput };